<h2 mat-dialog-title>{{ data.title }}</h2>
<mat-dialog-content>
  <p>{{ data.message }}</p>
</mat-dialog-content>
<mat-dialog-actions align="end">
  <button mat-button type="button" (click)="onCancel()">{{ data.cancelText }}</button>
  <button
    *ngIf="showSave"
    mat-stroked-button
    color="primary"
    type="button"
    (click)="onSave()"
  >
    {{ data.saveText }}
  </button>
  <button mat-button [color]="data.confirmColor" type="button" (click)="onConfirm()" cdkFocusInitial>
    {{ data.confirmText }}
  </button>
</mat-dialog-actions>
